module.exports = __webpack_public_path__ + "static/img/5009_phase_function_Paper_Points.4b000a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5009_phase_function_Paper_Points.png
// module id = vfoB
// module chunks = 0